import Container from './styled/Container'

const VariantText: any = Container

export default VariantText
